// ════════════════════════════════════════════════════════════════════════
// features.ts  —  Feature flags / kill-switches for CoreManage modules
// ════════════════════════════════════════════════════════════════════════
//
// Each flag can be controlled via a Vite env var at build time:
//   VITE_FEATURE_<NAME>=true   →  enabled
//   VITE_FEATURE_<NAME>=false  →  disabled (or just omit the variable)
//
// To re-enable a flag in production:
//   1. In Railway → frontend service → Variables → add VITE_FEATURE_OPPORTUNITIES=true
//   2. Trigger a redeploy (or push a commit to LGM_Develop, Railway will pick it up)
//
// For local dev, add to frontend/.env (gitignored):
//   VITE_FEATURE_OPPORTUNITIES=true
//
// All flags default to FALSE (disabled) to avoid leaking work-in-progress
// features into production accidentally.
// ════════════════════════════════════════════════════════════════════════

export function isEnabled(envName: string, fallback = false): boolean {
  const raw = (import.meta.env as Record<string, string | undefined>)[envName];
  if (raw === undefined || raw === null || raw === '') return fallback;
  const normalized = String(raw).toLowerCase().trim();
  return normalized === 'true' || normalized === '1' || normalized === 'yes';
}

export const FEATURES = {
  /**
   * US-36: Commercial Opportunities module.
   * When false:
   *   - The "Oportunidades" tab is hidden from ClientDetailPage
   *   - The detail page /clients/:clientId/opportunities/:id is unreachable
   *   - The admin page /admin/opportunity-step-templates is unreachable
   *
   * Backend endpoints continue to exist (we don't break the API), but
   * no UI entry point exposes them.
   */
  OPPORTUNITIES: isEnabled('VITE_FEATURE_OPPORTUNITIES', false),
};

export default FEATURES;
